import React from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';
import { Link as LinkScroll } from 'react-scroll';

function HeroSection() {
  return (
    <div className='hero-container'>
      <video src='/videos/video-2.mp4' autoPlay loop muted />
      <h1 style={{ fontSize: "80px" }}>CUTTING EDGE SOLUTIONS</h1>

      <div className='hero-btns'>
        <LinkScroll to='about' offset={-300} delay={300} smooth={true}>
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
          >
            LEARN MORE
          </Button>
        </LinkScroll>
        <LinkScroll to='contact' delay={300} smooth={true}>
          <Button
            className='btns'
            buttonStyle='btn--primary'
            buttonSize='btn--large'
          >
            CONTACT <i class="fas fa-id-card-alt"></i>
          </Button>
        </LinkScroll>

      </div>
    </div>
  );
}

export default HeroSection;
